import axiosInstance from '../../axiosInstance';

export const getPixellotTenants = async () => {
  const response = await axiosInstance.get(`/api/admin/v2/users/pix-tenants`);
  return response.data.data;
};

export default null;
